export default {
  title: 'Add saved credit card',
  description: "You can add your credit card for faster checkout.",

  addCard: 'Add Credit Card'
}